import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class LocationService {

  public navigator: Navigator;

  getLocation(): Promise<{lng: number, lat: number}> {
    if (navigator) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resp => {
          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
        },
        err => {
          reject(err);
        });
      });
    }
}

}
